<template lang="pug">
    .photo-album.container.content(v-if="contents && contents.length")
        //- .column.preview-img-list.is-offset-1.is-10(
        //-     v-if="displayMode === 'slide'"
        //-     ref="container"
        //- )
        //-     flickity( 
        //-         ref="flickity"
        //-         :options="flickityOptions"
        //-     )
        //-         figure.carousel-cell(
        //-             v-for="(box, index) in boxes"
        //-         )
        //-             img(
        //-                 :src="box.image.src"
        //-                 :title="box.data.title"
        //-             )
        .column.preview-img-list.is-offset-1.is-10(
            ref="container"
            :style="{ height: `${layoutGeometry.containerHeight}px` }"
        )
            figure(
                v-for="(box, index) in boxes"
                :style="{ top: `${box.style.top}px`, left: `${box.style.left}px` }"
            )
                a(href="#" @click.prevent="handleClick($event, index)")
                    AlbumImage(
                        class="preview-img-item"
                        :image="box.thumbnail"
                        :title="box.data.title"
                        :width="box.style.width"
                        :height="box.style.height"
                        :index="index"
                    )
                        caption(v-if="box.data.title || striptags(box.data.text)")
                            h4 {{ box.data.title }}
                            div( v-html="box.data.text" )
</template>

<script>

// import _ from 'lodash'
import get from 'lodash.get'
import cloneDeep from 'lodash.clonedeep'
import trim from 'lodash.trim'
import debounce from 'lodash.debounce'
import startsWith from 'lodash.startswith'

import Flickity from 'vue-flickity';

import striptags from 'striptags'
import justifiedLayout from 'justified-layout'

import router from '@/router';

import AlbumImage from './AlbumImage'

export default {
    name: 'PhotoAlbum',
    data() {
        return {
            flickityOptions: {
                initialIndex: 1,
                prevNextButtons: true,
                pageDots: false,
                wrapAround: false
            },
            config: {
                containerWidth: 800,
                containerPadding: {
                    top: undefined,
                    right: undefined,
                    bottom: undefined,
                    left: undefined,
                },
                boxSpacing: 10,
                targetRowHeight: 320,

            },
        }
    },
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    components: {
        AlbumImage,
        Flickity
    },
    computed: {
        displayMode() {
            let mode = 'slide';
            if( this.settings && this.settings.length ) {
                const setting = this.settings.find( setting => setting.key === 'display-mode' );
                mode = setting.value;
            }
            return mode;
        },
        settings() {
            return get(this.section, 'settings', []);
        },
        contents() {
            let contents = this.section.contents || []
            return cloneDeep(contents).sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0))
        },
        images() {
            let images = []

            this.contents.forEach(content => {
                const image = get(content, 'images.0')
                if (! image) return false

                image.title = content.title
                image.text = content.text

                images.push(image)
            })

            return images
        },
        ratios() {
            let ratios = []

            this.images.forEach(image => {
                const fz = get(image, 'pivot.z') || 1
                const w = get(image, 'pivot.w') || image.width / fz
                const h = get(image, 'pivot.h') || image.height / fz

                const ratio = w / h
                ratios.push(ratio)
            })

            return ratios
        },
        layoutGeometry() {
            return justifiedLayout(this.ratios, this.config)
        },
        boxes() {
            let boxes = []

            const storageRoute = trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            const calculateFit = (data, maxHeight) => {
                const pivot = data.pivot
                let fit = get(pivot, 'fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1'

                // let { w, h, x, y, z } = pivot
                let { w, h, z } = pivot
                if (! z) z = 1

                let width = data.width / z
                let height = data.height / z
                let aspectRatio = width / height

                maxHeight = Math.min(maxHeight, height)

                if (w && h) {

                    aspectRatio = w / h

                    if (h > maxHeight) {
                        height = maxHeight
                    }

                    if (height * aspectRatio > data.width / z) {
                        height = width / aspectRatio
                    } else {
                        width = height * aspectRatio
                    }

                    fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`)

                } else if (! w && ! h) {
                    if (height > maxHeight) {
                        height = maxHeight
                        width = height * aspectRatio
                    }

                    fit += `&w=${width}`
                }

                return {
                    src: `${storageRoute}/images/${data.id}/${data.name}?${fit}`,
                    error: `${storageRoute}/images/${data.id}/${data.name}?${fit}&preview=greyscale`,
                    loading: `${storageRoute}/images/${data.id}/${data.name}?${fit}&preview=blur`,
                    width,
                    height,
                    aspectRatio,
                }
            }

            this.images.forEach((el, i) => {
                const style = this.layoutGeometry.boxes[i]

                let data, thumbnail, image
                data = el

                image = calculateFit(data, 1800)
                thumbnail = calculateFit(data, 500)

                boxes.push({ style, data, thumbnail, image })
            })

            return boxes
        },

        photoSwipeItems() {
            let items = []

            this.boxes.forEach(box => {
                const src = box.image.src
                const w = box.image.width
                const h = box.image.height

                let title = ''
                if (box.data.title) title += `<h4>${box.data.title}</h4>`
                if (this.striptags(box.data.text)) title += box.data.text

                items.push({ src, w, h, title })
            })

            return items
        }
    },
    methods: {
        handleClick(event, i) {
            const content = this.contents[i]
            if (content && content.hyperlink) {
                const link = content.hyperlink.href

                let href, target, path
                switch (content.hyperlink.type) {
                    case 'internal':
                        path = get(content.hyperlink, 'menuItem.path')
                        if (path) {
                            router.push({ path })
                            return
                        }
                        break;
                    case 'external':
                        if (! startsWith(link, 'https://') && ! startsWith(link, 'http://')) href = `https://${link}`
                        else href = link
                        target = content.hyperlink.target || '_self'
                        break;

                    case 'mailto':
                        href = `mailto:${link}`
                        target = '_self'
                        break;

                    case 'tel':
                        href = `tel:${link}`
                        target = '_self'
                        break;
                }

                if (href) window.open(href, target);
                else this.$photoswipe.open(event, i, this.photoSwipeItems)
            } else {
                this.$photoswipe.open(event, i, this.photoSwipeItems)
            }
        },
        striptags(value) {
            return trim(striptags(value))
        },
        next() {
            this.$refs.flickity.next();
        },
        previous() {
            this.$refs.flickity.previous();
        }
    },
    mounted() {
        const calculateDimansions = () => {
            if (this.$refs.container) {
                const style = getComputedStyle(this.$refs.container)
                this.config.containerWidth = this.$refs.container.offsetWidth
                // this.config.containerWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)

                this.config.containerPadding = {
                    top: parseInt(style.paddingTop),
                    right: parseInt(style.paddingRight),
                    bottom: parseInt(style.paddingBottom),
                    left: parseInt(style.paddingLeft),
                }
            }
        }

        window.addEventListener('resize', debounce(calculateDimansions, 100))
        calculateDimansions()
    }
}

</script>

<style lang="sass" scoped>

    @import '~@/assets/sass/variables'

    ::v-deep .flickity-viewport
        min-height: 250px
    .photo-album.container.content .column
        position: relative
        figure
            background: #eeeeee
            border-radius: 4px
            position: absolute
            & > a
                & ::v-deep > .preview-img-item
                    transition: transform .3s cubic-bezier(0, 0.9, 0.31, 1.04)
                    & > img
                        transition: box-shadow .3s cubic-bezier(0, 0.9, 0.31, 1.04)
                    & > caption
                        transition: background .3s cubic-bezier(0, 0.9, 0.31, 1.04), backdrop-filter .3s cubic-bezier(0, 0.9, 0.31, 1.04)
                &:hover ::v-deep > .preview-img-item
                    position: relative
                    z-index: 2
                    transform: scale(1.015)
                    & > img
                        box-shadow: $box-shadow-3
                    & > caption
                        // opacity: 0.6
                        background: rgba(0,0,0,.3)
                        backdrop-filter: blur(2px)
            ::v-deep
                img
                    border-radius: 4px
                    display: block
                    &[lazy=loading]
                        box-shadow: none
                    &[lazy=loaded]
                        box-shadow: $box-shadow-2
                caption
                    font-size: .8rem
                    position: absolute
                    left: 0
                    bottom: 0
                    padding: 10px
                    right: 0
                    text-align: left
                    color: white
                    border-bottom-right-radius: 4px
                    border-bottom-left-radius: 4px
                    background: rgba(0,0,0,.8)
                    backdrop-filter: blur(6px)
                    h4
                        color: inherit
                        margin-bottom: 0
</style>
